import React from 'react';

import type { SvgIconClassKey } from '@mui/material';
import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function ModerateMarginsIcon(props: {
  classes?: Partial<Record<SvgIconClassKey, string>>;
}): JSX.Element {
  return (
    <SvgIcon
      classes={props.classes}
      style={{ display: 'block', height: 39, width: 32 }}
      viewBox="0 0 32 39"
    >
      <g fill="none" fillRule="evenodd">
        <rect fill="#FFF" height="38" rx="3" stroke={IconColors.Grey} width="31" x=".5" y=".5" />
        <path d="M4.5 1v36.999M31 33.499H1M31 5.499H1" stroke="#146EE8" />
        <path d="M27.5 1v36.999" opacity=".994" stroke="#146EE8" />
      </g>
    </SvgIcon>
  );
}
